import { IconButton } from '@material-ui/core'
import { Dropdown } from '../../../../../Dropdown'
import { Icon } from '../../../../../Icon'

import * as S from './styles'

type IndustryGroupFilterDropDownProps = {
  setDeleteIndustry?: () => void
}

export const IndustryGroupFilterDropDown = ({
  setDeleteIndustry
}: IndustryGroupFilterDropDownProps) => {
  return (
    <S.Wrapper>
      <Dropdown
        title={
          <IconButton
            id="action"
            color="inherit"
            aria-label="open drawer"
            onClick={() => {}}
            size="medium"
            edge="start"
          >
            <Icon
              icon="itens-interface-actions"
              width={12}
              height={12}
              aria-label="action"
            />
          </IconButton>
        }
      >
        <S.Nav>
          <S.Link onClick={setDeleteIndustry}>
            <Icon icon="dropdown-delete" height={16} width={16} />
            <span>Remover indústria</span>
          </S.Link>
        </S.Nav>
      </Dropdown>
    </S.Wrapper>
  )
}
